import React from 'react';
import { displayName } from '../../../../App';
import MainGuidanceLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/Statements/VisaClassic';

function VisaClassicStatements() {
  document.title = `${displayName}: Visa Classic | Statements`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default VisaClassicStatements;
